import { AuthProviders } from "@outschool/auth-shared";
import { Box } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { ContinueWithKakao, LoginUserFeedback } from "@outschool/ui-auth";
import React from "react";

import { useLearnerAuth } from "../../../providers/LearnerAuthProvider";
import { useLoginWithRedirect } from "./connectOidcUtils";

export default function ConnectKakao() {
  const { t } = useTranslation(
    "learnerApp\\Settings\\ConnectThirdPartyAccounts\\ConnectKakao"
  );
  const { learnerAuth } = useLearnerAuth();
  const hasKakao = React.useMemo(
    () => learnerAuth?.providers.includes(AuthProviders.Kakao) ?? false,
    [learnerAuth]
  );
  const userError = useLoginWithRedirect(AuthProviders.Kakao);

  return (
    <Box
      sx={{
        marginBottom: "0.5em"
      }}
    >
      {hasKakao ? (
        <Box>
          {t("Your Kakao account is linked and you may use it to log in.")}
        </Box>
      ) : (
        <Box>
          {userError && (
            <Box
              sx={{
                marginBottom: "0.5em"
              }}
            >
              <LoginUserFeedback
                userFeedbackMessage={userError}
                isError={true}
              />
            </Box>
          )}
          <ContinueWithKakao
            trackingName="learner_login.learner_settings.connect_with_kakao"
            isLearnerApp={true}
          />
        </Box>
      )}
    </Box>
  );
}
